function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! react-checkbox-tree - v1.7.1 | 2021 */

/*! For license information please see index.browser.js.LICENSE.txt */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ReactCheckboxTree = t(require("react")) : e.ReactCheckboxTree = t(e.React);
}(self, function (e) {
  return function () {
    var t = {
      4184: function _(e, t) {
        var r;
        !function () {
          "use strict";

          var n = {}.hasOwnProperty;

          function o() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              var r = arguments[t];

              if (r) {
                var a = _typeof(r);

                if ("string" === a || "number" === a) e.push(r);else if (Array.isArray(r)) {
                  if (r.length) {
                    var i = o.apply(null, r);
                    i && e.push(i);
                  }
                } else if ("object" === a) if (r.toString === Object.prototype.toString) for (var c in r) {
                  n.call(r, c) && r[c] && e.push(c);
                } else e.push(r.toString());
              }
            }

            return e.join(" ");
          }

          e.exports ? (o.default = o, e.exports = o) : void 0 === (r = function () {
            return o;
          }.apply(t, [])) || (e.exports = r);
        }();
      },
      8552: function _(e, t, r) {
        var n = r(852)(r(5639), "DataView");
        e.exports = n;
      },
      1989: function _(e, t, r) {
        var n = r(1789),
            o = r(401),
            a = r(7667),
            i = r(1327),
            c = r(1866);

        function l(e) {
          var t = -1,
              r = null == e ? 0 : e.length;

          for (this.clear(); ++t < r;) {
            var n = e[t];
            this.set(n[0], n[1]);
          }
        }

        l.prototype.clear = n, l.prototype.delete = o, l.prototype.get = a, l.prototype.has = i, l.prototype.set = c, e.exports = l;
      },
      8407: function _(e, t, r) {
        var n = r(7040),
            o = r(4125),
            a = r(2117),
            i = r(7518),
            c = r(4705);

        function l(e) {
          var t = -1,
              r = null == e ? 0 : e.length;

          for (this.clear(); ++t < r;) {
            var n = e[t];
            this.set(n[0], n[1]);
          }
        }

        l.prototype.clear = n, l.prototype.delete = o, l.prototype.get = a, l.prototype.has = i, l.prototype.set = c, e.exports = l;
      },
      7071: function _(e, t, r) {
        var n = r(852)(r(5639), "Map");
        e.exports = n;
      },
      3369: function _(e, t, r) {
        var n = r(4785),
            o = r(1285),
            a = r(6e3),
            i = r(9916),
            c = r(5265);

        function l(e) {
          var t = -1,
              r = null == e ? 0 : e.length;

          for (this.clear(); ++t < r;) {
            var n = e[t];
            this.set(n[0], n[1]);
          }
        }

        l.prototype.clear = n, l.prototype.delete = o, l.prototype.get = a, l.prototype.has = i, l.prototype.set = c, e.exports = l;
      },
      3818: function _(e, t, r) {
        var n = r(852)(r(5639), "Promise");
        e.exports = n;
      },
      8525: function _(e, t, r) {
        var n = r(852)(r(5639), "Set");
        e.exports = n;
      },
      8668: function _(e, t, r) {
        var n = r(3369),
            o = r(619),
            a = r(2385);

        function i(e) {
          var t = -1,
              r = null == e ? 0 : e.length;

          for (this.__data__ = new n(); ++t < r;) {
            this.add(e[t]);
          }
        }

        i.prototype.add = i.prototype.push = o, i.prototype.has = a, e.exports = i;
      },
      6384: function _(e, t, r) {
        var n = r(8407),
            o = r(7465),
            a = r(3779),
            i = r(7599),
            c = r(4758),
            l = r(4309);

        function s(e) {
          var t = this.__data__ = new n(e);
          this.size = t.size;
        }

        s.prototype.clear = o, s.prototype.delete = a, s.prototype.get = i, s.prototype.has = c, s.prototype.set = l, e.exports = s;
      },
      2705: function _(e, t, r) {
        var n = r(5639).Symbol;
        e.exports = n;
      },
      1149: function _(e, t, r) {
        var n = r(5639).Uint8Array;
        e.exports = n;
      },
      577: function _(e, t, r) {
        var n = r(852)(r(5639), "WeakMap");
        e.exports = n;
      },
      4963: function _(e) {
        e.exports = function (e, t) {
          for (var r = -1, n = null == e ? 0 : e.length, o = 0, a = []; ++r < n;) {
            var i = e[r];
            t(i, r, e) && (a[o++] = i);
          }

          return a;
        };
      },
      4636: function _(e, t, r) {
        var n = r(2545),
            o = r(5694),
            a = r(1469),
            i = r(4144),
            c = r(5776),
            l = r(6719),
            s = Object.prototype.hasOwnProperty;

        e.exports = function (e, t) {
          var r = a(e),
              u = !r && o(e),
              p = !r && !u && i(e),
              f = !r && !u && !p && l(e),
              d = r || u || p || f,
              h = d ? n(e.length, String) : [],
              y = h.length;

          for (var b in e) {
            !t && !s.call(e, b) || d && ("length" == b || p && ("offset" == b || "parent" == b) || f && ("buffer" == b || "byteLength" == b || "byteOffset" == b) || c(b, y)) || h.push(b);
          }

          return h;
        };
      },
      2488: function _(e) {
        e.exports = function (e, t) {
          for (var r = -1, n = t.length, o = e.length; ++r < n;) {
            e[o + r] = t[r];
          }

          return e;
        };
      },
      2908: function _(e) {
        e.exports = function (e, t) {
          for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
            if (t(e[r], r, e)) return !0;
          }

          return !1;
        };
      },
      8470: function _(e, t, r) {
        var n = r(7813);

        e.exports = function (e, t) {
          for (var r = e.length; r--;) {
            if (n(e[r][0], t)) return r;
          }

          return -1;
        };
      },
      8866: function _(e, t, r) {
        var n = r(2488),
            o = r(1469);

        e.exports = function (e, t, r) {
          var a = t(e);
          return o(e) ? a : n(a, r(e));
        };
      },
      4239: function _(e, t, r) {
        var n = r(2705),
            o = r(9607),
            a = r(2333),
            i = n ? n.toStringTag : void 0;

        e.exports = function (e) {
          return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : i && i in Object(e) ? o(e) : a(e);
        };
      },
      9454: function _(e, t, r) {
        var n = r(4239),
            o = r(7005);

        e.exports = function (e) {
          return o(e) && "[object Arguments]" == n(e);
        };
      },
      939: function _(e, t, r) {
        var n = r(2492),
            o = r(7005);

        e.exports = function e(t, r, a, i, c) {
          return t === r || (null == t || null == r || !o(t) && !o(r) ? t != t && r != r : n(t, r, a, i, e, c));
        };
      },
      2492: function _(e, t, r) {
        var n = r(6384),
            o = r(7114),
            a = r(8351),
            i = r(6096),
            c = r(4160),
            l = r(1469),
            s = r(4144),
            u = r(6719),
            p = "[object Arguments]",
            f = "[object Array]",
            d = "[object Object]",
            h = Object.prototype.hasOwnProperty;

        e.exports = function (e, t, r, y, b, v) {
          var g = l(e),
              m = l(t),
              x = g ? f : c(e),
              O = m ? f : c(t),
              k = (x = x == p ? d : x) == d,
              j = (O = O == p ? d : O) == d,
              _ = x == O;

          if (_ && s(e)) {
            if (!s(t)) return !1;
            g = !0, k = !1;
          }

          if (_ && !k) return v || (v = new n()), g || u(e) ? o(e, t, r, y, b, v) : a(e, t, x, r, y, b, v);

          if (!(1 & r)) {
            var w = k && h.call(e, "__wrapped__"),
                C = j && h.call(t, "__wrapped__");

            if (w || C) {
              var P = w ? e.value() : e,
                  E = C ? t.value() : t;
              return v || (v = new n()), b(P, E, r, y, v);
            }
          }

          return !!_ && (v || (v = new n()), i(e, t, r, y, b, v));
        };
      },
      8458: function _(e, t, r) {
        var n = r(3560),
            o = r(5346),
            a = r(3218),
            i = r(346),
            c = /^\[object .+?Constructor\]$/,
            l = Function.prototype,
            s = Object.prototype,
            u = l.toString,
            p = s.hasOwnProperty,
            f = RegExp("^" + u.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

        e.exports = function (e) {
          return !(!a(e) || o(e)) && (n(e) ? f : c).test(i(e));
        };
      },
      8749: function _(e, t, r) {
        var n = r(4239),
            o = r(1780),
            a = r(7005),
            i = {};
        i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, e.exports = function (e) {
          return a(e) && o(e.length) && !!i[n(e)];
        };
      },
      280: function _(e, t, r) {
        var n = r(5726),
            o = r(6916),
            a = Object.prototype.hasOwnProperty;

        e.exports = function (e) {
          if (!n(e)) return o(e);
          var t = [];

          for (var r in Object(e)) {
            a.call(e, r) && "constructor" != r && t.push(r);
          }

          return t;
        };
      },
      2545: function _(e) {
        e.exports = function (e, t) {
          for (var r = -1, n = Array(e); ++r < e;) {
            n[r] = t(r);
          }

          return n;
        };
      },
      1717: function _(e) {
        e.exports = function (e) {
          return function (t) {
            return e(t);
          };
        };
      },
      4757: function _(e) {
        e.exports = function (e, t) {
          return e.has(t);
        };
      },
      4429: function _(e, t, r) {
        var n = r(5639)["__core-js_shared__"];
        e.exports = n;
      },
      7114: function _(e, t, r) {
        var n = r(8668),
            o = r(2908),
            a = r(4757);

        e.exports = function (e, t, r, i, c, l) {
          var s = 1 & r,
              u = e.length,
              p = t.length;
          if (u != p && !(s && p > u)) return !1;
          var f = l.get(e),
              d = l.get(t);
          if (f && d) return f == t && d == e;
          var h = -1,
              y = !0,
              b = 2 & r ? new n() : void 0;

          for (l.set(e, t), l.set(t, e); ++h < u;) {
            var v = e[h],
                g = t[h];
            if (i) var m = s ? i(g, v, h, t, e, l) : i(v, g, h, e, t, l);

            if (void 0 !== m) {
              if (m) continue;
              y = !1;
              break;
            }

            if (b) {
              if (!o(t, function (e, t) {
                if (!a(b, t) && (v === e || c(v, e, r, i, l))) return b.push(t);
              })) {
                y = !1;
                break;
              }
            } else if (v !== g && !c(v, g, r, i, l)) {
              y = !1;
              break;
            }
          }

          return l.delete(e), l.delete(t), y;
        };
      },
      8351: function _(e, t, r) {
        var n = r(2705),
            o = r(1149),
            a = r(7813),
            i = r(7114),
            c = r(8776),
            l = r(1814),
            s = n ? n.prototype : void 0,
            u = s ? s.valueOf : void 0;

        e.exports = function (e, t, r, n, s, p, f) {
          switch (r) {
            case "[object DataView]":
              if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
              e = e.buffer, t = t.buffer;

            case "[object ArrayBuffer]":
              return !(e.byteLength != t.byteLength || !p(new o(e), new o(t)));

            case "[object Boolean]":
            case "[object Date]":
            case "[object Number]":
              return a(+e, +t);

            case "[object Error]":
              return e.name == t.name && e.message == t.message;

            case "[object RegExp]":
            case "[object String]":
              return e == t + "";

            case "[object Map]":
              var d = c;

            case "[object Set]":
              var h = 1 & n;
              if (d || (d = l), e.size != t.size && !h) return !1;
              var y = f.get(e);
              if (y) return y == t;
              n |= 2, f.set(e, t);
              var b = i(d(e), d(t), n, s, p, f);
              return f.delete(e), b;

            case "[object Symbol]":
              if (u) return u.call(e) == u.call(t);
          }

          return !1;
        };
      },
      6096: function _(e, t, r) {
        var n = r(8234),
            o = Object.prototype.hasOwnProperty;

        e.exports = function (e, t, r, a, i, c) {
          var l = 1 & r,
              s = n(e),
              u = s.length;
          if (u != n(t).length && !l) return !1;

          for (var p = u; p--;) {
            var f = s[p];
            if (!(l ? f in t : o.call(t, f))) return !1;
          }

          var d = c.get(e),
              h = c.get(t);
          if (d && h) return d == t && h == e;
          var y = !0;
          c.set(e, t), c.set(t, e);

          for (var b = l; ++p < u;) {
            var v = e[f = s[p]],
                g = t[f];
            if (a) var m = l ? a(g, v, f, t, e, c) : a(v, g, f, e, t, c);

            if (!(void 0 === m ? v === g || i(v, g, r, a, c) : m)) {
              y = !1;
              break;
            }

            b || (b = "constructor" == f);
          }

          if (y && !b) {
            var x = e.constructor,
                O = t.constructor;
            x == O || !("constructor" in e) || !("constructor" in t) || "function" == typeof x && x instanceof x && "function" == typeof O && O instanceof O || (y = !1);
          }

          return c.delete(e), c.delete(t), y;
        };
      },
      1957: function _(e, t, r) {
        var n = "object" == _typeof(r.g) && r.g && r.g.Object === Object && r.g;
        e.exports = n;
      },
      8234: function _(e, t, r) {
        var n = r(8866),
            o = r(9551),
            a = r(3674);

        e.exports = function (e) {
          return n(e, a, o);
        };
      },
      5050: function _(e, t, r) {
        var n = r(7019);

        e.exports = function (e, t) {
          var r = e.__data__;
          return n(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
        };
      },
      852: function _(e, t, r) {
        var n = r(8458),
            o = r(7801);

        e.exports = function (e, t) {
          var r = o(e, t);
          return n(r) ? r : void 0;
        };
      },
      9607: function _(e, t, r) {
        var n = r(2705),
            o = Object.prototype,
            a = o.hasOwnProperty,
            i = o.toString,
            c = n ? n.toStringTag : void 0;

        e.exports = function (e) {
          var t = a.call(e, c),
              r = e[c];

          try {
            e[c] = void 0;
            var n = !0;
          } catch (e) {}

          var o = i.call(e);
          return n && (t ? e[c] = r : delete e[c]), o;
        };
      },
      9551: function _(e, t, r) {
        var n = r(4963),
            o = r(479),
            a = Object.prototype.propertyIsEnumerable,
            i = Object.getOwnPropertySymbols,
            c = i ? function (e) {
          return null == e ? [] : (e = Object(e), n(i(e), function (t) {
            return a.call(e, t);
          }));
        } : o;
        e.exports = c;
      },
      4160: function _(e, t, r) {
        var n = r(8552),
            o = r(7071),
            a = r(3818),
            i = r(8525),
            c = r(577),
            l = r(4239),
            s = r(346),
            u = "[object Map]",
            p = "[object Promise]",
            f = "[object Set]",
            d = "[object WeakMap]",
            h = "[object DataView]",
            y = s(n),
            b = s(o),
            v = s(a),
            g = s(i),
            m = s(c),
            x = l;
        (n && x(new n(new ArrayBuffer(1))) != h || o && x(new o()) != u || a && x(a.resolve()) != p || i && x(new i()) != f || c && x(new c()) != d) && (x = function x(e) {
          var t = l(e),
              r = "[object Object]" == t ? e.constructor : void 0,
              n = r ? s(r) : "";
          if (n) switch (n) {
            case y:
              return h;

            case b:
              return u;

            case v:
              return p;

            case g:
              return f;

            case m:
              return d;
          }
          return t;
        }), e.exports = x;
      },
      7801: function _(e) {
        e.exports = function (e, t) {
          return null == e ? void 0 : e[t];
        };
      },
      1789: function _(e, t, r) {
        var n = r(4536);

        e.exports = function () {
          this.__data__ = n ? n(null) : {}, this.size = 0;
        };
      },
      401: function _(e) {
        e.exports = function (e) {
          var t = this.has(e) && delete this.__data__[e];
          return this.size -= t ? 1 : 0, t;
        };
      },
      7667: function _(e, t, r) {
        var n = r(4536),
            o = Object.prototype.hasOwnProperty;

        e.exports = function (e) {
          var t = this.__data__;

          if (n) {
            var r = t[e];
            return "__lodash_hash_undefined__" === r ? void 0 : r;
          }

          return o.call(t, e) ? t[e] : void 0;
        };
      },
      1327: function _(e, t, r) {
        var n = r(4536),
            o = Object.prototype.hasOwnProperty;

        e.exports = function (e) {
          var t = this.__data__;
          return n ? void 0 !== t[e] : o.call(t, e);
        };
      },
      1866: function _(e, t, r) {
        var n = r(4536);

        e.exports = function (e, t) {
          var r = this.__data__;
          return this.size += this.has(e) ? 0 : 1, r[e] = n && void 0 === t ? "__lodash_hash_undefined__" : t, this;
        };
      },
      5776: function _(e) {
        var t = /^(?:0|[1-9]\d*)$/;

        e.exports = function (e, r) {
          var n = _typeof(e);

          return !!(r = null == r ? 9007199254740991 : r) && ("number" == n || "symbol" != n && t.test(e)) && e > -1 && e % 1 == 0 && e < r;
        };
      },
      7019: function _(e) {
        e.exports = function (e) {
          var t = _typeof(e);

          return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
        };
      },
      5346: function _(e, t, r) {
        var n,
            o = r(4429),
            a = (n = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "";

        e.exports = function (e) {
          return !!a && a in e;
        };
      },
      5726: function _(e) {
        var t = Object.prototype;

        e.exports = function (e) {
          var r = e && e.constructor;
          return e === ("function" == typeof r && r.prototype || t);
        };
      },
      7040: function _(e) {
        e.exports = function () {
          this.__data__ = [], this.size = 0;
        };
      },
      4125: function _(e, t, r) {
        var n = r(8470),
            o = Array.prototype.splice;

        e.exports = function (e) {
          var t = this.__data__,
              r = n(t, e);
          return !(r < 0 || (r == t.length - 1 ? t.pop() : o.call(t, r, 1), --this.size, 0));
        };
      },
      2117: function _(e, t, r) {
        var n = r(8470);

        e.exports = function (e) {
          var t = this.__data__,
              r = n(t, e);
          return r < 0 ? void 0 : t[r][1];
        };
      },
      7518: function _(e, t, r) {
        var n = r(8470);

        e.exports = function (e) {
          return n(this.__data__, e) > -1;
        };
      },
      4705: function _(e, t, r) {
        var n = r(8470);

        e.exports = function (e, t) {
          var r = this.__data__,
              o = n(r, e);
          return o < 0 ? (++this.size, r.push([e, t])) : r[o][1] = t, this;
        };
      },
      4785: function _(e, t, r) {
        var n = r(1989),
            o = r(8407),
            a = r(7071);

        e.exports = function () {
          this.size = 0, this.__data__ = {
            hash: new n(),
            map: new (a || o)(),
            string: new n()
          };
        };
      },
      1285: function _(e, t, r) {
        var n = r(5050);

        e.exports = function (e) {
          var t = n(this, e).delete(e);
          return this.size -= t ? 1 : 0, t;
        };
      },
      6e3: function _(e, t, r) {
        var n = r(5050);

        e.exports = function (e) {
          return n(this, e).get(e);
        };
      },
      9916: function _(e, t, r) {
        var n = r(5050);

        e.exports = function (e) {
          return n(this, e).has(e);
        };
      },
      5265: function _(e, t, r) {
        var n = r(5050);

        e.exports = function (e, t) {
          var r = n(this, e),
              o = r.size;
          return r.set(e, t), this.size += r.size == o ? 0 : 1, this;
        };
      },
      8776: function _(e) {
        e.exports = function (e) {
          var t = -1,
              r = Array(e.size);
          return e.forEach(function (e, n) {
            r[++t] = [n, e];
          }), r;
        };
      },
      4536: function _(e, t, r) {
        var n = r(852)(Object, "create");
        e.exports = n;
      },
      6916: function _(e, t, r) {
        var n = r(5569)(Object.keys, Object);
        e.exports = n;
      },
      1167: function _(e, t, r) {
        e = r.nmd(e);

        var n = r(1957),
            o = t && !t.nodeType && t,
            a = o && e && !e.nodeType && e,
            i = a && a.exports === o && n.process,
            c = function () {
          try {
            return a && a.require && a.require("util").types || i && i.binding && i.binding("util");
          } catch (e) {}
        }();

        e.exports = c;
      },
      2333: function _(e) {
        var t = Object.prototype.toString;

        e.exports = function (e) {
          return t.call(e);
        };
      },
      5569: function _(e) {
        e.exports = function (e, t) {
          return function (r) {
            return e(t(r));
          };
        };
      },
      5639: function _(e, t, r) {
        var n = r(1957),
            o = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
            a = n || o || Function("return this")();
        e.exports = a;
      },
      619: function _(e) {
        e.exports = function (e) {
          return this.__data__.set(e, "__lodash_hash_undefined__"), this;
        };
      },
      2385: function _(e) {
        e.exports = function (e) {
          return this.__data__.has(e);
        };
      },
      1814: function _(e) {
        e.exports = function (e) {
          var t = -1,
              r = Array(e.size);
          return e.forEach(function (e) {
            r[++t] = e;
          }), r;
        };
      },
      7465: function _(e, t, r) {
        var n = r(8407);

        e.exports = function () {
          this.__data__ = new n(), this.size = 0;
        };
      },
      3779: function _(e) {
        e.exports = function (e) {
          var t = this.__data__,
              r = t.delete(e);
          return this.size = t.size, r;
        };
      },
      7599: function _(e) {
        e.exports = function (e) {
          return this.__data__.get(e);
        };
      },
      4758: function _(e) {
        e.exports = function (e) {
          return this.__data__.has(e);
        };
      },
      4309: function _(e, t, r) {
        var n = r(8407),
            o = r(7071),
            a = r(3369);

        e.exports = function (e, t) {
          var r = this.__data__;

          if (r instanceof n) {
            var i = r.__data__;
            if (!o || i.length < 199) return i.push([e, t]), this.size = ++r.size, this;
            r = this.__data__ = new a(i);
          }

          return r.set(e, t), this.size = r.size, this;
        };
      },
      346: function _(e) {
        var t = Function.prototype.toString;

        e.exports = function (e) {
          if (null != e) {
            try {
              return t.call(e);
            } catch (e) {}

            try {
              return e + "";
            } catch (e) {}
          }

          return "";
        };
      },
      7813: function _(e) {
        e.exports = function (e, t) {
          return e === t || e != e && t != t;
        };
      },
      5694: function _(e, t, r) {
        var n = r(9454),
            o = r(7005),
            a = Object.prototype,
            i = a.hasOwnProperty,
            c = a.propertyIsEnumerable,
            l = n(function () {
          return arguments;
        }()) ? n : function (e) {
          return o(e) && i.call(e, "callee") && !c.call(e, "callee");
        };
        e.exports = l;
      },
      1469: function _(e) {
        var t = Array.isArray;
        e.exports = t;
      },
      8612: function _(e, t, r) {
        var n = r(3560),
            o = r(1780);

        e.exports = function (e) {
          return null != e && o(e.length) && !n(e);
        };
      },
      4144: function _(e, t, r) {
        e = r.nmd(e);
        var n = r(5639),
            o = r(5062),
            a = t && !t.nodeType && t,
            i = a && e && !e.nodeType && e,
            c = i && i.exports === a ? n.Buffer : void 0,
            l = (c ? c.isBuffer : void 0) || o;
        e.exports = l;
      },
      8446: function _(e, t, r) {
        var n = r(939);

        e.exports = function (e, t) {
          return n(e, t);
        };
      },
      3560: function _(e, t, r) {
        var n = r(4239),
            o = r(3218);

        e.exports = function (e) {
          if (!o(e)) return !1;
          var t = n(e);
          return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
        };
      },
      1780: function _(e) {
        e.exports = function (e) {
          return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
        };
      },
      3218: function _(e) {
        e.exports = function (e) {
          var t = _typeof(e);

          return null != e && ("object" == t || "function" == t);
        };
      },
      7005: function _(e) {
        e.exports = function (e) {
          return null != e && "object" == _typeof(e);
        };
      },
      6719: function _(e, t, r) {
        var n = r(8749),
            o = r(1717),
            a = r(1167),
            i = a && a.isTypedArray,
            c = i ? o(i) : n;
        e.exports = c;
      },
      3674: function _(e, t, r) {
        var n = r(4636),
            o = r(280),
            a = r(8612);

        e.exports = function (e) {
          return a(e) ? n(e) : o(e);
        };
      },
      8306: function _(e, t, r) {
        var n = r(3369);

        function o(e, t) {
          if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");

          var r = function r() {
            var n = arguments,
                o = t ? t.apply(this, n) : n[0],
                a = r.cache;
            if (a.has(o)) return a.get(o);
            var i = e.apply(this, n);
            return r.cache = a.set(o, i) || a, i;
          };

          return r.cache = new (o.Cache || n)(), r;
        }

        o.Cache = n, e.exports = o;
      },
      479: function _(e) {
        e.exports = function () {
          return [];
        };
      },
      5062: function _(e) {
        e.exports = function () {
          return !1;
        };
      },
      2703: function _(e, t, r) {
        "use strict";

        var n = r(414);

        function o() {}

        function a() {}

        a.resetWarningCache = o, e.exports = function () {
          function e(e, t, r, o, a, i) {
            if (i !== n) {
              var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw c.name = "Invariant Violation", c;
            }
          }

          function t() {
            return e;
          }

          e.isRequired = e;
          var r = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: a,
            resetWarningCache: o
          };
          return r.PropTypes = r, r;
        };
      },
      5697: function _(e, t, r) {
        e.exports = r(2703)();
      },
      414: function _(e) {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      4698: function _(t) {
        "use strict";

        t.exports = e;
      }
    },
        r = {};

    function n(e) {
      var o = r[e];
      if (void 0 !== o) return o.exports;
      var a = r[e] = {
        id: e,
        loaded: !1,
        exports: {}
      };
      return t[e](a, a.exports, n), a.loaded = !0, a.exports;
    }

    n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, {
        a: t
      }), t;
    }, n.d = function (e, t) {
      for (var r in t) {
        n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, n.g = function () {
      if ("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis))) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) return window;
      }
    }(), n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.nmd = function (e) {
      return e.paths = [], e.children || (e.children = []), e;
    };
    var o = {};
    return function () {
      "use strict";

      n.r(o), n.d(o, {
        default: function _default() {
          return xe;
        },
        expandNodesToLevel: function expandNodesToLevel() {
          return me;
        }
      });
      var e = n(4184),
          t = n.n(e),
          r = n(8446),
          a = n.n(r),
          i = n(8306),
          c = n.n(i);

      var l = function l() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
        var t = "",
            r = crypto.getRandomValues(new Uint8Array(e));

        for (; e--;) {
          var _n = 63 & r[e];

          t += _n < 36 ? _n.toString(36) : _n < 62 ? (_n - 26).toString(36).toUpperCase() : _n < 63 ? "_" : "-";
        }

        return t;
      };

      var s = n(5697),
          u = n.n(s),
          p = n(4698),
          f = n.n(p);

      function d(e) {
        return (d = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
          return _typeof(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
        })(e);
      }

      var h = ["children", "title"];

      function y() {
        return (y = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];

            for (var n in r) {
              Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
          }

          return e;
        }).apply(this, arguments);
      }

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      function g(e, t) {
        return (g = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      function m(e, t) {
        return !t || "object" !== d(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }

      function x(e) {
        return (x = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function O(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      var k = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && g(e, t);
        }(i, e);
        var t,
            r,
            n,
            o,
            a = (n = i, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              t = x(n);

          if (o) {
            var r = x(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);

          return m(this, e);
        });

        function i() {
          return b(this, i), a.apply(this, arguments);
        }

        return t = i, (r = [{
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.children,
                r = e.title,
                n = function (e, t) {
              if (null == e) return {};

              var r,
                  n,
                  o = function (e, t) {
                if (null == e) return {};
                var r,
                    n,
                    o = {},
                    a = Object.keys(e);

                for (n = 0; n < a.length; n++) {
                  r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
                }

                return o;
              }(e, t);

              if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);

                for (n = 0; n < a.length; n++) {
                  r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
                }
              }

              return o;
            }(e, h);

            return f().createElement("button", y({
              "aria-label": r,
              title: r,
              type: "button"
            }, n), t);
          }
        }]) && v(t.prototype, r), i;
      }(f().PureComponent);

      O(k, "propTypes", {
        children: u().node.isRequired,
        title: u().string
      }), O(k, "defaultProps", {
        title: null
      });
      var j = k,
          _ = {
        ALL: "all",
        PARENT: "parent",
        LEAF: "leaf"
      };

      function w(e) {
        this.message = e, this.stack = Error().stack;
      }

      w.prototype = Object.create(Error.prototype), w.prototype.name = "CheckboxTreeError";
      var C = w;

      function P(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function E(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      function N(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function A(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var S = _;

      var R = function () {
        function e(t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          N(this, e), this.props = t, this.flatNodes = r;
        }

        var t, r;
        return t = e, (r = [{
          key: "setProps",
          value: function value(e) {
            this.props = e;
          }
        }, {
          key: "clone",
          value: function value() {
            var t = this,
                r = {};
            return Object.keys(this.flatNodes).forEach(function (e) {
              var n = t.flatNodes[e];

              r[e] = function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var r = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? P(Object(r), !0).forEach(function (t) {
                    E(e, t, r[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : P(Object(r)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                  });
                }

                return e;
              }({}, n);
            }), new e(this.props, r);
          }
        }, {
          key: "getNode",
          value: function value(e) {
            return this.flatNodes[e];
          }
        }, {
          key: "reset",
          value: function value() {
            this.flatNodes = {};
          }
        }, {
          key: "flattenNodes",
          value: function value(e) {
            var t = this,
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;

            if (Array.isArray(e) && 0 !== e.length) {
              var o = this.props,
                  a = o.disabled,
                  i = o.noCascade;
              e.forEach(function (e, o) {
                var c = t.nodeHasChildren(e);
                if (void 0 !== t.flatNodes[e.value]) throw new C("Duplicate value '".concat(e.value, "' detected. All node values must be unique."));
                t.flatNodes[e.value] = {
                  label: e.label,
                  value: e.value,
                  children: e.children,
                  parent: r,
                  isChild: void 0 !== r.value,
                  isParent: c,
                  isLeaf: !c,
                  showCheckbox: void 0 === e.showCheckbox || e.showCheckbox,
                  disabled: t.getDisabledState(e, r, a, i),
                  treeDepth: n,
                  index: o
                }, t.flattenNodes(e.children, e, n + 1);
              });
            }
          }
        }, {
          key: "nodeHasChildren",
          value: function value(e) {
            return Array.isArray(e.children);
          }
        }, {
          key: "getDisabledState",
          value: function value(e, t, r, n) {
            return !!r || !(n || !t.disabled) || Boolean(e.disabled);
          }
        }, {
          key: "deserializeLists",
          value: function value(e) {
            var t = this,
                r = ["checked", "expanded"];
            Object.keys(this.flatNodes).forEach(function (e) {
              r.forEach(function (r) {
                t.flatNodes[e][r] = !1;
              });
            }), r.forEach(function (r) {
              e[r].forEach(function (e) {
                void 0 !== t.flatNodes[e] && (t.flatNodes[e][r] = !0);
              });
            });
          }
        }, {
          key: "serializeList",
          value: function value(e) {
            var t = this,
                r = [];
            return Object.keys(this.flatNodes).forEach(function (n) {
              t.flatNodes[n][e] && r.push(n);
            }), r;
          }
        }, {
          key: "expandAllNodes",
          value: function value(e) {
            var t = this;
            return Object.keys(this.flatNodes).forEach(function (r) {
              t.flatNodes[r].isParent && (t.flatNodes[r].expanded = e);
            }), this;
          }
        }, {
          key: "toggleChecked",
          value: function value(e, t, r, n) {
            var o = this,
                a = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
                i = this.flatNodes[e.value],
                c = [S.PARENT, S.ALL].indexOf(r) > -1,
                l = [S.LEAF, S.ALL].indexOf(r) > -1;

            if (i.isLeaf || n) {
              if (e.disabled) return this;
              this.toggleNode(e.value, "checked", t);
            } else c && this.toggleNode(e.value, "checked", t), l && i.children.forEach(function (e) {
              o.toggleChecked(e, t, r, n, !1);
            });

            return a && !n && i.isChild && c && this.toggleParentStatus(i.parent, r), this;
          }
        }, {
          key: "toggleParentStatus",
          value: function value(e, t) {
            var r = this.flatNodes[e.value];
            r.isChild ? (t === S.ALL && this.toggleNode(e.value, "checked", this.isEveryChildChecked(r)), this.toggleParentStatus(r.parent, t)) : this.toggleNode(e.value, "checked", this.isEveryChildChecked(r));
          }
        }, {
          key: "isEveryChildChecked",
          value: function value(e) {
            var t = this;
            return e.children.every(function (e) {
              return t.getNode(e.value).checked;
            });
          }
        }, {
          key: "toggleNode",
          value: function value(e, t, r) {
            return this.flatNodes[e][t] = r, this;
          }
        }]) && A(t.prototype, r), e;
      }();

      function T(e) {
        return (T = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
          return _typeof(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
        })(e);
      }

      function L() {
        return (L = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];

            for (var n in r) {
              Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
          }

          return e;
        }).apply(this, arguments);
      }

      function D(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function I(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function z(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      function q(e, t) {
        return (q = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      function B(e, t) {
        return !t || "object" !== T(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }

      function F(e) {
        return (F = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function M(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      var U = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && q(e, t);
        }(i, e);
        var t,
            r,
            n,
            o,
            a = (n = i, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              t = F(n);

          if (o) {
            var r = F(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);

          return B(this, e);
        });

        function i() {
          return I(this, i), a.apply(this, arguments);
        }

        return t = i, (r = [{
          key: "componentDidMount",
          value: function value() {
            this.updateDeterminateProperty();
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.updateDeterminateProperty();
          }
        }, {
          key: "updateDeterminateProperty",
          value: function value() {
            var e = this.props.indeterminate;
            this.checkbox.indeterminate = e;
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
                t = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? D(Object(r), !0).forEach(function (t) {
                  M(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : D(Object(r)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
              }

              return e;
            }({}, this.props);

            return delete t.indeterminate, f().createElement("input", L({}, t, {
              ref: function ref(t) {
                e.checkbox = t;
              },
              type: "checkbox"
            }));
          }
        }]) && z(t.prototype, r), i;
      }(f().PureComponent);

      M(U, "propTypes", {
        indeterminate: u().bool
      }), M(U, "defaultProps", {
        indeterminate: !1
      });
      var H = U,
          $ = u().shape({
        check: u().node,
        uncheck: u().node,
        halfCheck: u().node,
        expandClose: u().node,
        expandOpen: u().node,
        expandAll: u().node,
        collapseAll: u().node,
        parentClose: u().node,
        parentOpen: u().node,
        leaf: u().node
      }),
          V = u().shape({
        collapseAll: u().string.isRequired,
        expandAll: u().string.isRequired,
        toggle: u().string.isRequired
      });

      function W(e) {
        return (W = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
          return _typeof(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
        })(e);
      }

      function J(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      function K(e, t) {
        return (K = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      function G(e, t) {
        return !t || "object" !== W(t) && "function" != typeof t ? Y(e) : t;
      }

      function Y(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }

      function Q(e) {
        return (Q = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function X(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      var Z = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && K(e, t);
        }(c, e);
        var r,
            n,
            o,
            a,
            i = (o = c, a = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              t = Q(o);

          if (a) {
            var r = Q(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);

          return G(this, e);
        });

        function c(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (t = i.call(this, e)).onCheck = t.onCheck.bind(Y(t)), t.onClick = t.onClick.bind(Y(t)), t.onExpand = t.onExpand.bind(Y(t)), t;
        }

        return r = c, (n = [{
          key: "onCheck",
          value: function value() {
            var e = this.props,
                t = e.value;
            (0, e.onCheck)({
              value: t,
              checked: this.getCheckState({
                toggle: !0
              })
            });
          }
        }, {
          key: "onClick",
          value: function value() {
            var e = this.props,
                t = e.expandOnClick,
                r = e.isParent,
                n = e.value,
                o = e.onClick;
            r && t && this.onExpand(), o({
              value: n,
              checked: this.getCheckState({
                toggle: !1
              })
            });
          }
        }, {
          key: "onExpand",
          value: function value() {
            var e = this.props,
                t = e.expanded,
                r = e.value;
            (0, e.onExpand)({
              value: r,
              expanded: !t
            });
          }
        }, {
          key: "getCheckState",
          value: function value(e) {
            var t = e.toggle,
                r = this.props,
                n = r.checked,
                o = r.optimisticToggle;
            return !(0 !== n || !t) || 1 === n && !t || 2 === n && o;
          }
        }, {
          key: "renderCollapseButton",
          value: function value() {
            var e = this.props,
                t = e.expandDisabled,
                r = e.isLeaf,
                n = e.lang;
            return r ? f().createElement("span", {
              className: "rct-collapse"
            }, f().createElement("span", {
              className: "rct-icon"
            })) : f().createElement(j, {
              className: "rct-collapse rct-collapse-btn",
              disabled: t,
              title: n.toggle,
              onClick: this.onExpand
            }, this.renderCollapseIcon());
          }
        }, {
          key: "renderCollapseIcon",
          value: function value() {
            var e = this.props,
                t = e.expanded,
                r = e.icons,
                n = r.expandClose,
                o = r.expandOpen;
            return t ? o : n;
          }
        }, {
          key: "renderCheckboxIcon",
          value: function value() {
            var e = this.props,
                t = e.checked,
                r = e.icons,
                n = r.uncheck,
                o = r.check,
                a = r.halfCheck;
            return 0 === t ? n : 1 === t ? o : a;
          }
        }, {
          key: "renderNodeIcon",
          value: function value() {
            var e = this.props,
                t = e.expanded,
                r = e.icon,
                n = e.icons,
                o = n.leaf,
                a = n.parentClose,
                i = n.parentOpen,
                c = e.isLeaf;
            return null !== r ? r : c ? o : t ? i : a;
          }
        }, {
          key: "renderBareLabel",
          value: function value(e) {
            var t = this.props,
                r = t.onClick,
                n = t.title,
                o = null !== r;
            return f().createElement("span", {
              className: "rct-bare-label",
              title: n
            }, o ? f().createElement("span", {
              className: "rct-node-clickable",
              onClick: this.onClick,
              onKeyPress: this.onClick,
              role: "button",
              tabIndex: 0
            }, e) : e);
          }
        }, {
          key: "renderCheckboxLabel",
          value: function value(e) {
            var t = this.props,
                r = t.checked,
                n = t.disabled,
                o = t.title,
                a = t.treeId,
                i = t.value,
                c = null !== t.onClick,
                l = "".concat(a, "-").concat(String(i).split(" ").join("_")),
                s = [f().createElement("label", {
              key: 0,
              htmlFor: l,
              title: o
            }, f().createElement(H, {
              checked: 1 === r,
              disabled: n,
              id: l,
              indeterminate: 2 === r,
              onClick: this.onCheck,
              onChange: function onChange() {}
            }), f().createElement("span", {
              className: "rct-checkbox"
            }, this.renderCheckboxIcon()), c ? null : e)];
            return c && s.push(f().createElement("span", {
              key: 1,
              className: "rct-node-clickable",
              onClick: this.onClick,
              onKeyPress: this.onClick,
              role: "link",
              tabIndex: 0
            }, e)), s;
          }
        }, {
          key: "renderLabel",
          value: function value() {
            var e = this.props,
                t = e.label,
                r = e.showCheckbox,
                n = [e.showNodeIcon ? f().createElement("span", {
              key: 0,
              className: "rct-node-icon"
            }, this.renderNodeIcon()) : null, f().createElement("span", {
              key: 1,
              className: "rct-title"
            }, t)];
            return r ? this.renderCheckboxLabel(n) : this.renderBareLabel(n);
          }
        }, {
          key: "renderChildren",
          value: function value() {
            return this.props.expanded ? this.props.children : null;
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                r = e.className,
                n = e.disabled,
                o = e.expanded,
                a = e.isLeaf,
                i = t()({
              "rct-node": !0,
              "rct-node-leaf": a,
              "rct-node-parent": !a,
              "rct-node-expanded": !a && o,
              "rct-node-collapsed": !a && !o,
              "rct-disabled": n
            }, r);
            return f().createElement("li", {
              className: i
            }, f().createElement("span", {
              className: "rct-text"
            }, this.renderCollapseButton(), this.renderLabel()), this.renderChildren());
          }
        }]) && J(r.prototype, n), c;
      }(f().PureComponent);

      X(Z, "propTypes", {
        checked: u().number.isRequired,
        disabled: u().bool.isRequired,
        expandDisabled: u().bool.isRequired,
        expanded: u().bool.isRequired,
        icons: $.isRequired,
        isLeaf: u().bool.isRequired,
        isParent: u().bool.isRequired,
        label: u().node.isRequired,
        lang: V.isRequired,
        optimisticToggle: u().bool.isRequired,
        showNodeIcon: u().bool.isRequired,
        treeId: u().string.isRequired,
        value: u().oneOfType([u().string, u().number]).isRequired,
        onCheck: u().func.isRequired,
        onExpand: u().func.isRequired,
        children: u().node,
        className: u().string,
        expandOnClick: u().bool,
        icon: u().node,
        showCheckbox: u().bool,
        title: u().string,
        onClick: u().func
      }), X(Z, "defaultProps", {
        children: null,
        className: null,
        expandOnClick: !1,
        icon: null,
        showCheckbox: !0,
        title: null,
        onClick: function onClick() {}
      });
      var ee = Z,
          te = u().oneOfType([u().arrayOf(u().string), u().arrayOf(u().number)]);

      function re(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function ne(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? re(Object(r), !0).forEach(function (t) {
            oe(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : re(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }

      function oe(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      var ae = {
        label: u().node.isRequired,
        value: u().oneOfType([u().string, u().number]).isRequired,
        disabled: u().bool,
        icon: u().node,
        showCheckbox: u().bool,
        title: u().string
      };
      var ie = u().oneOfType([u().shape(ae), u().shape(ne(ne({}, ae), {}, {
        children: u().arrayOf(ae).isRequired
      }))]);

      function ce(e) {
        return (ce = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
          return _typeof(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
        })(e);
      }

      function le(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function se(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? le(Object(r), !0).forEach(function (t) {
            ye(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : le(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }

      function ue(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      function pe(e, t) {
        return (pe = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      function fe(e, t) {
        return !t || "object" !== ce(t) && "function" != typeof t ? de(e) : t;
      }

      function de(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }

      function he(e) {
        return (he = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function ye(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      var be = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && pe(e, t);
        }(p, e);
        var r,
            n,
            o,
            i,
            s,
            u = (i = p, s = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              t = he(i);

          if (s) {
            var r = he(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);

          return fe(this, e);
        });

        function p(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, p), t = u.call(this, e);
          var r = new R(e);
          return r.flattenNodes(e.nodes), r.deserializeLists({
            checked: e.checked,
            expanded: e.expanded
          }), t.state = {
            id: e.id || "rct-".concat(l()),
            model: r,
            prevProps: e
          }, t.onCheck = t.onCheck.bind(de(t)), t.onExpand = t.onExpand.bind(de(t)), t.onNodeClick = t.onNodeClick.bind(de(t)), t.onExpandAll = t.onExpandAll.bind(de(t)), t.onCollapseAll = t.onCollapseAll.bind(de(t)), t.combineMemorized = c()(function (e, t) {
            return se(se({}, e), t);
          }).bind(de(t)), t;
        }

        return r = p, o = [{
          key: "getDerivedStateFromProps",
          value: function value(e, t) {
            var r = t.model,
                n = t.prevProps,
                o = e.disabled,
                i = e.id,
                c = e.nodes,
                l = se(se({}, t), {}, {
              prevProps: e
            });
            return r.setProps(e), a()(n.nodes, c) && n.disabled === o || (r.reset(), r.flattenNodes(c)), null !== i && (l = se(se({}, l), {}, {
              id: i
            })), r.deserializeLists({
              checked: e.checked,
              expanded: e.expanded
            }), l;
          }
        }], (n = [{
          key: "onCheck",
          value: function value(e) {
            var t = this.props,
                r = t.checkModel,
                n = t.noCascade,
                o = t.onCheck,
                a = this.state.model.clone(),
                i = a.getNode(e.value);
            a.toggleChecked(e, e.checked, r, n), o(a.serializeList("checked"), se(se({}, i), e));
          }
        }, {
          key: "onExpand",
          value: function value(e) {
            var t = this.props.onExpand,
                r = this.state.model.clone(),
                n = r.getNode(e.value);
            r.toggleNode(e.value, "expanded", e.expanded), t(r.serializeList("expanded"), se(se({}, n), e));
          }
        }, {
          key: "onNodeClick",
          value: function value(e) {
            (0, this.props.onClick)(se(se({}, this.state.model.getNode(e.value)), e));
          }
        }, {
          key: "onExpandAll",
          value: function value() {
            this.expandAllNodes();
          }
        }, {
          key: "onCollapseAll",
          value: function value() {
            this.expandAllNodes(!1);
          }
        }, {
          key: "expandAllNodes",
          value: function value() {
            var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                t = this.props.onExpand;
            t(this.state.model.clone().expandAllNodes(e).serializeList("expanded"));
          }
        }, {
          key: "determineShallowCheckState",
          value: function value(e, t) {
            var r = this.state.model.getNode(e.value);
            return r.isLeaf || t ? r.checked ? 1 : 0 : this.isEveryChildChecked(e) ? 1 : this.isSomeChildChecked(e) ? 2 : 0;
          }
        }, {
          key: "isEveryChildChecked",
          value: function value(e) {
            var t = this;
            return e.children.every(function (e) {
              return 1 === t.state.model.getNode(e.value).checkState;
            });
          }
        }, {
          key: "isSomeChildChecked",
          value: function value(e) {
            var t = this;
            return e.children.some(function (e) {
              return t.state.model.getNode(e.value).checkState > 0;
            });
          }
        }, {
          key: "renderTreeNodes",
          value: function value(e) {
            var t = this,
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = this.props,
                o = n.expandDisabled,
                a = n.expandOnClick,
                i = n.icons,
                c = n.lang,
                l = n.noCascade,
                s = n.onClick,
                u = n.onlyLeafCheckboxes,
                d = n.optimisticToggle,
                h = n.showNodeTitle,
                y = n.showNodeIcon,
                b = this.state,
                v = b.id,
                g = b.model,
                m = p.defaultProps.icons,
                x = e.map(function (e) {
              var n = e.value,
                  p = g.getNode(e.value),
                  b = p.isParent ? t.renderTreeNodes(e.children, e) : null;
              p.checkState = t.determineShallowCheckState(e, l);
              var x = u ? p.isLeaf : p.showCheckbox;
              return !r.value || g.getNode(r.value).expanded ? f().createElement(ee, {
                key: n,
                checked: p.checkState,
                className: e.className,
                disabled: p.disabled,
                expandDisabled: o,
                expandOnClick: a,
                expanded: p.expanded,
                icon: e.icon,
                icons: t.combineMemorized(m, i),
                label: e.label,
                lang: c,
                optimisticToggle: d,
                isLeaf: p.isLeaf,
                isParent: p.isParent,
                showCheckbox: x,
                showNodeIcon: y,
                title: h ? e.title || e.label : e.title,
                treeId: v,
                value: e.value,
                onCheck: t.onCheck,
                onClick: s && t.onNodeClick,
                onExpand: t.onExpand
              }, b) : null;
            });
            return f().createElement("ol", null, x);
          }
        }, {
          key: "renderExpandAll",
          value: function value() {
            var e = this.props,
                t = e.icons,
                r = t.expandAll,
                n = t.collapseAll,
                o = e.lang;
            return e.showExpandAll ? f().createElement("div", {
              className: "rct-options"
            }, f().createElement(j, {
              className: "rct-option rct-option-expand-all",
              title: o.expandAll,
              onClick: this.onExpandAll
            }, r), f().createElement(j, {
              className: "rct-option rct-option-collapse-all",
              title: o.collapseAll,
              onClick: this.onCollapseAll
            }, n)) : null;
          }
        }, {
          key: "renderHiddenInput",
          value: function value() {
            var e = this.props,
                t = e.name,
                r = e.nameAsArray;
            return void 0 === t ? null : r ? this.renderArrayHiddenInput() : this.renderJoinedHiddenInput();
          }
        }, {
          key: "renderArrayHiddenInput",
          value: function value() {
            var e = this.props,
                t = e.checked,
                r = e.name;
            return t.map(function (e) {
              var t = "".concat(r, "[]");
              return f().createElement("input", {
                key: e,
                name: t,
                type: "hidden",
                value: e
              });
            });
          }
        }, {
          key: "renderJoinedHiddenInput",
          value: function value() {
            var e = this.props,
                t = e.checked,
                r = e.name,
                n = t.join(",");
            return f().createElement("input", {
              name: r,
              type: "hidden",
              value: n
            });
          }
        }, {
          key: "render",
          value: function value() {
            var e,
                r = this.props,
                n = r.direction,
                o = r.disabled,
                a = r.iconsClass,
                i = r.nodes,
                c = r.nativeCheckboxes,
                l = this.state.id,
                s = this.renderTreeNodes(i),
                u = t()((ye(e = {
              "react-checkbox-tree": !0,
              "rct-disabled": o
            }, "rct-icons-".concat(a), !0), ye(e, "rct-native-display", c), ye(e, "rct-direction-rtl", "rtl" === n), e));
            return f().createElement("div", {
              className: u,
              id: l
            }, this.renderExpandAll(), this.renderHiddenInput(), s);
          }
        }]) && ue(r.prototype, n), o && ue(r, o), p;
      }(f().Component);

      function ve(e) {
        return function (e) {
          if (Array.isArray(e)) return ge(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return ge(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ge(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function ge(e, t) {
        (null == t || t > e.length) && (t = e.length);

        for (var r = 0, n = new Array(t); r < t; r++) {
          n[r] = e[r];
        }

        return n;
      }

      function me(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        if (r > t) return [];
        var n = [];
        return e.forEach(function (e) {
          e.children && (n = [].concat(ve(n), [e.value], ve(me(e.children, t, r + 1))));
        }), n;
      }

      ye(be, "propTypes", {
        nodes: u().arrayOf(ie).isRequired,
        checkModel: u().oneOf([_.LEAF, _.ALL]),
        checked: te,
        direction: u().string,
        disabled: u().bool,
        expandDisabled: u().bool,
        expandOnClick: u().bool,
        expanded: te,
        icons: $,
        iconsClass: u().string,
        id: u().string,
        lang: V,
        name: u().string,
        nameAsArray: u().bool,
        nativeCheckboxes: u().bool,
        noCascade: u().bool,
        onlyLeafCheckboxes: u().bool,
        optimisticToggle: u().bool,
        showExpandAll: u().bool,
        showNodeIcon: u().bool,
        showNodeTitle: u().bool,
        onCheck: u().func,
        onClick: u().func,
        onExpand: u().func
      }), ye(be, "defaultProps", {
        checkModel: _.LEAF,
        checked: [],
        direction: "ltr",
        disabled: !1,
        expandDisabled: !1,
        expandOnClick: !1,
        expanded: [],
        icons: {
          check: f().createElement("span", {
            className: "rct-icon rct-icon-check"
          }),
          uncheck: f().createElement("span", {
            className: "rct-icon rct-icon-uncheck"
          }),
          halfCheck: f().createElement("span", {
            className: "rct-icon rct-icon-half-check"
          }),
          expandClose: f().createElement("span", {
            className: "rct-icon rct-icon-expand-close"
          }),
          expandOpen: f().createElement("span", {
            className: "rct-icon rct-icon-expand-open"
          }),
          expandAll: f().createElement("span", {
            className: "rct-icon rct-icon-expand-all"
          }),
          collapseAll: f().createElement("span", {
            className: "rct-icon rct-icon-collapse-all"
          }),
          parentClose: f().createElement("span", {
            className: "rct-icon rct-icon-parent-close"
          }),
          parentOpen: f().createElement("span", {
            className: "rct-icon rct-icon-parent-open"
          }),
          leaf: f().createElement("span", {
            className: "rct-icon rct-icon-leaf"
          })
        },
        iconsClass: "fa4",
        id: null,
        lang: {
          collapseAll: "Collapse all",
          expandAll: "Expand all",
          toggle: "Toggle"
        },
        name: void 0,
        nameAsArray: !1,
        nativeCheckboxes: !1,
        noCascade: !1,
        onlyLeafCheckboxes: !1,
        optimisticToggle: !0,
        showExpandAll: !1,
        showNodeIcon: !0,
        showNodeTitle: !1,
        onCheck: function onCheck() {},
        onClick: null,
        onExpand: function onExpand() {}
      });
      var xe = be;
    }(), o;
  }();
});